import React from 'react';

const AboutMe = () => {
    return (
        <div className="bg-dark mx-auto py-4">
            <div className="text-light py-4">
                <h1>About Me</h1>
                <div className="container w-100 py-4 fs-4">
                    <p className="d-flex justify-content-start">Bismillahir  Rahmanir Rahim, Assalamualaikum Warahmatullah!
                        I'm Karima Aktari a junior MERN Stack developer (still learning more). Already I have done 12 projects through learning. And achieved skills.</p>
                    <p className="d-flex justify-content-start">
                        Now I am comfortable with HTML, CSS, JavaScript,Bootstrap, React JS , Express Js, Node Js, MongoDB, Firebase and familiar with React-bootstrap, Material-UI, Tailwind, Axios.</p>
                    <p>I can use Github, Vs code, Chrome dev tool,  Netlify, Firebase, Heroku as a tools.</p>
                    <br />
                    <p> As a Junior MERN Stack Developer, I'm seeking an opportunity to use my skill.</p>

                    <div> ----------------------------</div>
                    <p> My-Github: https://github.com/Karima-Aktari</p>
                    <p>Email: karimaaktari911@gmail.com</p>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;